module.exports = __webpack_public_path__ + "static/tetleys-coaches-living-wage-employer-accreditation-83f0a8659c34667f5419f48a56bdc06d.png";